import { render, staticRenderFns } from "./padding.vue?vue&type=template&id=af92d5da&scoped=true&lang=pug&"
import script from "./padding.vue?vue&type=script&lang=js&"
export * from "./padding.vue?vue&type=script&lang=js&"
import style0 from "./padding.vue?vue&type=style&index=0&id=af92d5da&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af92d5da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('af92d5da', component.options)
    } else {
      api.reload('af92d5da', component.options)
    }
    module.hot.accept("./padding.vue?vue&type=template&id=af92d5da&scoped=true&lang=pug&", function () {
      api.rerender('af92d5da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/padding.vue"
export default component.exports